// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"e83800a9","453":"28d231d9","806":"cf07aefd"}[chunkId] + ".chunk.js";
};